<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<auth v-if="authShow" :extra="authExtra" :authtab="authTab" @submit="authSubmit" @back="authBack" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
					"type": "$select",
					"field": "fieldtype",
					"title": "字段类型",
					"value": "system",
					"hidden": false,
					"options": [{
						"value": 'system',
						"label": '系统',
					}, {
						"value": 'form',
						"label": '表单',
					}],
					"props": {},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "targetfield",
					"title": "字段",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "symbol",
					"title": "算术符",
					"options": [{
						"value": '等于',
						"label": '等于',
					}, {
						"value": '不等于',
						"label": '不等于',
					}, {
						"value": '大于',
						"label": '大于',
					}, {
						"value": '小于',
						"label": '小于',
					}, {
						"value": '大于等于',
						"label": '大于等于',
					}, {
						"value": '小于等于',
						"label": '小于等于',
					}, {
						"value": '存在于',
						"label": '存在于',
					}, {
						"value": '不存在于',
						"label": '不存在于',
					}],
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "value",
					"title": "值",
					"props": {
						"type": "date"
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import auth from '@_system/components/auth/index.vue'
	export default {
		mixins: [modalMixins],
		props: {
			param: {
				default: () => {
					return {}
				}
			},
			data: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '表达式',
				modal_width: 600,
				modal_height: 500,
				formfieldoptions: [],
				systemfieldoptions: [{
					value: 'rootid_system',
					label: '所属公司',
					rule: {
						type: "$department",
						field: "value",
						title: "值",
						value: null,
						hidden: false,
						props: {
							ismodal: false,
							multiple: true,
							collapseTags: false
						},
						validate: [{
							"required": false,
							"message": "必填项"
						}]
					}
				}, {
					value: 'ISmaster_system',
					label: '是否主管',
					rule: {
						type: "$emun",
						field: "value",
						title: "值",
						value: null,
						hidden: false,
						props: {
							name: 'enable'
						},
						validate: [{
							"required": false,
							"message": "必填项"
						}]
					}
				}, {
					value: 'hasmaster_system',
					label: '是否有主管',
					rule: {
						type: "$emun",
						field: "value",
						title: "值",
						value: null,
						hidden: false,
						props: {
							name: 'enable'
						},
						validate: [{
							"required": false,
							"message": "必填项"
						}]
					}
				}, {
					value: 'joblevel_system',
					label: '职务级别',
					rule: {
						type: "$joblevel",
						field: "value",
						title: "值",
						value: null,
						hidden: false,
						props: {
							multiple: true
						},
						validate: [{
							"required": false,
							"message": "必填项"
						}]
					}
				}, {
					value: 'postjobsystem',
					label: '岗位',
					rule: {
						type: "$postjob",
						field: "value",
						title: "值",
						value: null,
						hidden: false,
						props: {
							multiple: true,
							collapseTags: false
						},
						validate: [{
							"required": false,
							"message": "必填项"
						}]
					}
				}, {
					value: 'hassecondarydepartment_system',
					label: '是否存在次部门',
					rule: {
						type: "$emun",
						field: "value",
						title: "值",
						value: null,
						hidden: false,
						props: {
							name: 'enable'
						},
						validate: [{
							"required": false,
							"message": "必填项"
						}]
					}
				}],
				authShow:false,
				authTab:['staff','relation','formitem'],
				authExtra:{},
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.authExtra.formid = this.param.formid
				this.$api.form.get(this.param.formid, {
					onlyfield: true
				}).then((res) => {
					let formfieldoptions = []
					res.forEach((item) => {
						let rule = JSON.parse(JSON.stringify(item))
						if(item.field.endsWith('staffid') || item.field.endsWith('departmentid')){
							rule.type = 'button'
							rule.on = {
								click:()=>{
									if(item.field.endsWith('staffid')){
										this.authModal('staff')
									}else{
										this.authModal('department')
									}
									
								}
							}
							rule.children = ['选择']
							rule.props.type = 'primary'
							rule.props.size = 'mini'
						}
						rule.field = 'value'
						rule.title = '值'
						rule.validate = [{
							required: true,
							message: "必填项"
						}]
						formfieldoptions.push({
							value: item.table + '|' + item.field,
							label:  '【' + item.tablename + '】' + item.title,
							rule: rule
						})
					})
					this.formfieldoptions = formfieldoptions


					let formData = JSON.parse(JSON.stringify(formjson))
					let rule = formData.rule.rule
					let option = formData.rule.option
					rule.forEach((item) => {
						if (item.field == 'targetfield') {
							item.options = this.systemfieldoptions
						}
					})
					option.el = this.$refs.logistictrace_custom_form
					this.fApi = this.$formCreate(rule, option)
					this.fApi.nextTick(() => {
						this.regestevent(rule)
						this.setFormData()
					})
					this.$emit('show')
				})
			},
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			setFormData() {
				if (this.sourceData) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			fieldtypeChange(e) {
				let rule = this.fApi.getRule('targetfield')
				this.fApi.removeRule(rule)
				this.fApi.setValue('targetfield', null)
				this.fApi.setValue('value', null)
				this.fApi.setValue('symbol', null)
				if (e == 'form') {
					rule.options = this.formfieldoptions
				} else {
					rule.options = this.systemfieldoptions
				}
				let valuerule = this.fApi.getRule('value')
				this.fApi.removeRule(valuerule)
				this.$nextTick(() => {
					this.fApi.append({
						type: "$input",
						field: "value",
						title: "值",
						value: null,
						hidden: false,
						validate: [{
							required: true,
							message: "必填项"
						}]
					}, 'symbol')
					this.fApi.prepend(rule, 'symbol')
				})
			},
			targetfieldChange(e) {
				let fieldtype = this.fApi.getValue('fieldtype')
				let obj = this.getfield(fieldtype,e)
				let rule = this.fApi.getRule('value')
				this.fApi.removeRule(rule)
				this.$nextTick(() => {
					if (obj) {
						this.fApi.append(obj.rule, 'symbol')
					} else {
						this.fApi.append({
							type: "$input",
							field: "value",
							title: "值",
							value: null,
							hidden: false,
							validate: [{
								required: true,
								message: "必填项"
							}]
						}, 'symbol')
					}
				})
			},
			getfield(fieldtype,value){
				let obj = null
				if (fieldtype == 'system') {
					obj = this.systemfieldoptions.find((item) => {
						return item.value == value
					})
				}
				if (fieldtype == 'form') {
					obj = this.formfieldoptions.find((item) => {
						return item.value == value
					})
				}
				return obj
			},
			authModal(type){
				this.authExtra.value = this.fApi.getValue('value')
				if(type == 'staff'){
					this.authTab = ['staff','relation','formitem']
				}
				if(type == 'department'){
					this.authTab = ['department','relationdepartment','formitem']
				}
				this.authShow = true
			},
			authSubmit(e){
				this.fApi.setValue('value', {auth:e.data})
			},
			authBack(){				
				this.authShow = false
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
					// 	this.$emit('success')
					// 	this.modal_cancel()
					// })
					console.log(submitData)
					// this.getgrid().validate(true, (res) => {
					// 	if (!res) {
					// 		let submitData = JSON.parse(JSON.stringify(formData))
					// 		this.submitDataFormater(submitData)
					// 		let detail = this.getgrid().getTableData().fullData
					// 		let data = {}
					// 		data.main = submitData
					// 		data.costorder_detail = detail
					// 		this.createJson(data)
					// 		//console.log(data,123123)
					// 		this.$emit('success', {
					// 			data: JSON.stringify(data)
					// 		})
					// 		this.modal_cancel()
					// 		console.log(data)
					// 	} else {
					// 		for (let i in res) {
					// 			this.$message.error('缺少必填项：' + res[i][0].column.title)
					// 		}
					// 	}
					// })
				})
				//this.init()
			},
			submitDataFormater(formData) {
				let obj = this.getfield(formData.fieldtype,formData.targetfield)	
				let valuerule = this.fApi.getRule('value')
				let valuetext = ''
				if(formData.targetfield.endsWith('time')){
					formData.value = formData.value / 1000
					valuetext = window.systemMethods.timestampToDate(formData.value)
				}
				if(formData.targetfield.endsWith('staffid')){
					for(let i in formData.value.auth){
						if(formData.value.auth[i].length && !valuetext){
							valuetext = formData.value.auth[i][0].name
						}
					}
				}
				if(formData.targetfield.endsWith('departmentid')){
					for(let i in formData.value.auth){
						if(formData.value.auth[i].length && !valuetext){
							valuetext = formData.value.auth[i][0].name
						}
					}
				}
				if(valuerule.type == '$emun'){
					valuetext = window.systemMethods.getEmunValue(valuerule.props.name,formData.value)
				}
				
				

				// console.log(valuetext)
				// console.log(this.fApi.getRule('value'))
				formData.name = obj.label + '【'+formData.symbol+'】' + valuetext
				
			},
			reset() {
				//this.init()
			}
		},
		components: {
			auth
		}
	}
</script>